(() => {
  const money = (cents) => 'US$' + (cents / 100).toFixed(2);
  class InkRollMaterials {
    constructor(root) {
      this.root = root;
      this.group = root.querySelector('[data-roll-materials]');
      this.strings = JSON.parse(this.group.querySelector('[data-material-strings]').textContent);
      this.usd = this.group.dataset.currency === 'USD';
      this.data = window.inkRollMaterialPrices;
      this.form = document.getElementById(root.dataset.formId);
      this.group.querySelectorAll('[data-material-id]').forEach(input => {
        input.disabled = false;
      });
      this.form?.addEventListener('submit', event => {
        if (!this.requiresQuote()) return;
        event.preventDefault();
        event.stopImmediatePropagation();
      }, true);
    }

    material() {
      return this.group.querySelector('[data-material-id]:checked')?.dataset.materialId || 'vinyl';
    }

    requiresQuote() {
      return this.material() !== 'vinyl';
    }

    surcharge(selection, material = selection.material || this.material()) {
      if (material === 'vinyl') return 0;
      if (!this.data) return null;
      const key = [selection.size, selection.finish, String(selection.quantity)].join('|');
      const cents = this.data.grid[key]?.[material];
      return Number.isFinite(cents) ? cents : null;
    }

    variantFor(variant, selection) {
      if (!variant) return null;
      if ((selection.material || this.material()) === 'vinyl') return variant;
      const extra = this.surcharge(selection);
      const base = this.usd ? Number(variant.price) : this.data?.baseUsd?.[String(variant.id)];
      if (extra === null || !Number.isFinite(base)) return {...variant, materialQuoteRequired: true};
      return {...variant, price: base + extra, materialEstimate: true, estimateCurrency: 'USD'};
    }

    update(selection, variant, variants) {
      const material = this.material();
      const quoted = this.requiresQuote();
      const extra = this.surcharge(selection);
      const pricePending = quoted && (extra === null || variant.materialQuoteRequired === true);
      this.group.querySelectorAll('[data-material-option]').forEach(option => {
        const extra = this.surcharge(selection, option.dataset.materialOption);
        option.querySelector('[data-material-delta]').textContent = option.dataset.materialOption === 'vinyl'
          ? this.strings.included
          : extra === null ? this.strings.quote : this.strings.estimate.replace('{amount}', money(extra));
      });
      this.group.querySelector('[data-material-description]').textContent = this.strings[material + '_copy'];
      this.root.querySelector('[data-material-total-label]').textContent = pricePending ? this.strings.quote : quoted ? this.strings.total + ' (USD)' : this.strings.price;
      const summary = this.root.querySelector('[data-order-summary]');
      summary.textContent += ' · ' + this.strings[material + '_name'];
      this.root.querySelector('[data-tier-summary]').textContent = quoted ? this.strings.preview_note : '';
      if (pricePending) {
        this.root.querySelector('#priceTicker').textContent = '—';
        this.root.querySelector('[data-summary-unit]').textContent = '';
        this.root.querySelectorAll('[data-quantity-total]').forEach(total => { total.textContent = this.strings.quote; });
        this.root.querySelectorAll('[data-quantity-unit], [data-size-delta], [data-finish-delta]').forEach(delta => { delta.textContent = ''; });
      } else if (quoted) {
        this.root.querySelector('#priceTicker').textContent = money(Number(variant.price));
        this.root.querySelector('[data-summary-unit]').textContent = money(Number(variant.price) / Number(selection.quantity)) + ' ' + this.strings.per_label;
        this.root.querySelectorAll('[data-quantity-option]').forEach(option => {
          const quantity = option.dataset.quantityValue;
          const base = variants.find(item => String(item.option1 || item.options?.[0]) === String(selection.size)
            && String(item.option2 || item.options?.[1]) === String(selection.finish)
            && String(item.option3 || item.options?.[2]) === String(quantity));
          const estimate = this.variantFor(base, {...selection, quantity});
          const ready = estimate && !estimate.materialQuoteRequired;
          option.querySelector('[data-quantity-total]').textContent = ready ? money(estimate.price) : this.strings.quote;
          option.querySelector('[data-quantity-unit]').textContent = ready ? money(estimate.price / Number(quantity)) + ' ' + this.strings.per_label : '';
        });
        this.root.querySelectorAll('[data-size-delta], [data-finish-delta]').forEach(delta => { delta.textContent = delta.textContent.replace('$', 'US$'); });
      }
      const upload = this.root.querySelector('[data-ink-artwork-upload]');
      if (upload) upload.hidden = quoted;
      const checkout = this.root.querySelector('[data-native-checkout]');
      checkout.hidden = quoted;
      checkout.disabled = quoted || variant.available === false;
      checkout.setAttribute('aria-disabled', String(checkout.disabled));
      const footerNote = this.root.querySelector('.ink-native-calculator__checkout > small');
      if (footerNote) footerNote.hidden = quoted;
      const quote = this.root.querySelector('[data-material-quote]');
      quote.hidden = !quoted;
      const price = Number(variant.price || 0);
      const body = [
        'Please confirm a quote for custom roll labels.',
        'Material: ' + this.strings[material + '_name'],
        'Size: ' + selection.size,
        'Finish: ' + selection.finish,
        'Quantity: ' + selection.quantity,
        'Core: ' + (selection.rollCoreDiameter || '3 inch'),
        'Unwind: ' + (selection.unwindDirection || 'Bottom'),
        pricePending ? 'Please confirm pricing in ' + this.group.dataset.currency + '.' : 'Estimated total (USD): ' + money(price),
        'I understand the final price requires confirmation.'
      ].join('\n');
      quote.href = 'mailto:supports@inkelligent.com?subject=' + encodeURIComponent('Custom roll label quote') + '&body=' + encodeURIComponent(body);
      this.group.querySelector('.ink-roll-materials__notice').textContent = this.strings.usd_only;
    }
  }
  window.InkRollMaterials = InkRollMaterials;
})();
